/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Use_Different_EmailInputs */



/**
* | output |
* | --- |
* | "Use a different email" |
*
* @param {Login_Use_Different_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_use_different_email = /** @type {((inputs?: Login_Use_Different_EmailInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Use_Different_EmailInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utiliser un autre email")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usar un correo diferente")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Usar um e-mail diferente")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa un'email diversa")
	return /** @type {LocalizedString} */ ("Use a different email")
});